import React from 'react';
import {Map} from 'immutable';
import {percent, px} from '@packages/systems/core/utils/WebflowCssSubset';
import {CART_STATES} from '@packages/systems/commerce/constants';
import {
  Environment,
  WebflowEnvironments,
} from '@packages/systems/core-constants';
import {getCommerceDataProperty} from './ContextUtils';

import {Atom} from '@packages/systems/wfdl';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {useRuntimeEnvironment} from '@packages/systems/render';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';
import {UserItem} from './utils/OrderItemsUtils';

const styleDisplayNone = Map({style: Map({display: 'none'})});

const getUserItems = getCommerceDataProperty('userItems', []);

const shouldThisComponentBeShown = ({
  runtimeEnvironment,
  tempState,
  userItems,
}: {
  runtimeEnvironment: Environment;
  tempState: unknown;
  userItems: UserItem[];
}) => {
  const isDesigner = runtimeEnvironment === WebflowEnvironments.DESIGNER;

  if (isDesigner) {
    return tempState === CART_STATES.EMPTY;
  }
  return !(userItems && userItems.length > 0);
};

const CommerceCartEmptyState = Atom.createRender((props) => {
  const {attributes, classes, context, data, generateAttributes, renderChild} =
    props;

  const runtimeEnvironment = useRuntimeEnvironment();
  const tempState = context.get('tempState');
  const userItems = getUserItems(context);

  const styledAttributes = shouldThisComponentBeShown({
    runtimeEnvironment,
    tempState,
    userItems,
  })
    ? attributes
    : attributes.mergeDeep(styleDisplayNone);
  return (
    <div {...generateAttributes(styledAttributes, classes)}>
      {getChildren(data).map((child: EvaluatedNodeData) => renderChild(child))}
    </div>
  );
});

const config = createIntegratedAtom({
  displayName: 'Empty State',
  showEmpty: true,
  constraints: {
    pinToParent: true,
  },
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'flex',
          paddingTop: px(100),
          paddingBottom: px(100),
          justifyContent: 'center',
          alignItems: 'center',
          flexGrow: 1,
          flexShrink: 1,
          flexBasis: percent(0),
        },
      },
    },
  },
  render: CommerceCartEmptyState,
  fields: {children: TListOfElement},
});

export default config;
